export const ERROR_TAG_STYLE = {
  height: '.8em',
  lineHeight: '2em',
  backgroundColor: 'none',
  border: '1px solid #c50022',
  color: '#c50022',
  padding: '.1em .5em',
  paddingBottom: '3px',
};
